import { useAppState } from 'hooks/useAppState';
import { useUser } from 'hooks/useUser';

export const useSignedIn = (): boolean => {
  const { authType } = useAppState();

  return authType !== null && authType !== 'NONE';
};

export const useSignedInFull = () => {
  const signedIn = useSignedIn();

  const user = useUser();

  return signedIn && user !== null;
};
